<script setup lang="ts">
import { ECMSType, ECMSPage, EHomePageSectionType } from '@/modules/adminModule/constants/pagesCMSconstants'
defineProps<{
	disableAos?: boolean
}>()
// const { isTablet_sm } = useWindowWidth()
const localePath = useLocalePath()
const { locale } = useI18n()
const { getLocaleLang } = usei18nService()
const { storeLink } = useStoreLink()

const pageSections = inject<Ref<IHomePageSectionModel[]>>('pageSections')!

const fallbackBanners = ref()

if (!pageSections) {
	try {
		const type = await ApiService.fetchPageSectionByName(ECMSType.SUBPAGE, ECMSPage.HOME, EHomePageSectionType.BANNERS)
		if (type) fallbackBanners.value = type?.translations.find((t: { language: string; content: any }) => t.language === getLocaleLang())?.content
	} catch (error) {
		logger.log(error)
	}
}

const banners = ref()

watchEffect(() => {
	const section = pageSections?.value?.find((s: IHomePageSectionModel) => s.name === EHomePageSectionType.BANNERS)
	const content =
		section?.translations.find((t: { language: string; content: any }) => t.language === getLocaleLang())?.content ?? fallbackBanners.value
	if (content) banners.value = content
})
</script>

<template>
	<section v-if="banners" class="promo-banners">
		<Swiper
			class="promo-banners__swiper"
			:slides-per-view="1"
			:space-between="10"
			:breakpoints="{ 1101: { slidesPerView: 3, spaceBetween: 16 } }">
			<SwiperSlide>
				<NuxtLink :to="storeLink" target="_blank" rel="nofollow noopener">
					<article class="promo-banners__item promo-banners__item--smaller-pr promo-banners__item--full promo-banners__item--black">
						<div class="promo-banners__item-badge">{{ banners[0].name }}</div>
						<h3 class="promo-banners__item-title">
							<span v-html="banners[0].text"></span>{{ ' ' }}
							<span class="promo-banners__item-title--color" v-html="banners[0].colorText"></span>
						</h3>
						<GlobalImage
							class="promo-banners__item-background"
							alt="Promo banners arrow"
							src="promo-banners-arrow.png"
							loading="eager"
							sizes="640px sm:440px" />
					</article>
				</NuxtLink>
			</SwiperSlide>
			<SwiperSlide>
				<NuxtLink :to="localePath('loyalty-program')">
					<article class="promo-banners__item">
						<div class="promo-banners__item-badge"><GlobalIcon :name="banners[1].icons?.[0]" :width="24" /></div>
						<h3 class="promo-banners__item-title promo-banners__item-title-1" v-html="banners[1].text"></h3>
						<GlobalImage class="promo-banners__item-image" alt="Promo banners cards" src="promo-banners-cards.png" sizes="440px" />
					</article>
				</NuxtLink>
			</SwiperSlide>
			<SwiperSlide>
				<NuxtLink :to="`https://aplikacja.carfree.pl/${locale === 'pl' ? '' : 'en/home'}`" target="_blank">
					<article class="promo-banners__item">
						<div>
							<div class="promo-banners__item-badge promo-banners__item-badge--white">
								<GlobalIcon :name="banners[2].icons?.[0]" :width="18" />
							</div>
							<div class="promo-banners__item-badge promo-banners__item-badge--white">
								<GlobalIcon :name="banners[2].icons?.[1]" :width="18" />
							</div>
						</div>
						<h3 class="promo-banners__item-title promo-banners__item-title-2" v-html="banners[2].text"></h3>
						<GlobalImage class="promo-banners__item-image" alt="Promo banners phones" src="promo-banners-phones.png" sizes="440px" />
					</article>
				</NuxtLink>
			</SwiperSlide>
			<PromoBannersSwiperDots class="promo-banners__dots" />
		</Swiper>
	</section>
</template>

<style scoped lang="scss" src="./PromoBanners.scss"></style>
